import * as types from 'store/modules/profileimg/mutation-types'
import profileimg from 'api/profileimg'
import swal from 'sweetalert'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  state: {
    filepath: '',
    flgToggle: true
  },
  getters: {
    [types.GET_PROFILEIMG_FILEPATH] (state) {
      return (state.filepath === '') ? '' : state.filepath + '?' + Math.floor(Math.random() * Math.floor(9999))
    },
    [types.GET_PROFILEIMG_TOGGLE] (state) {
      return state.flgToggle
    }
  },
  mutations: {
    [types.SET_PROFILEIMG_FILEPATH] (state, filepath) {
      state.filepath = filepath
    },
    [types.SET_PROFILEIMG_TOGGLE] (state, flgToggle) {
      state.flgToggle = flgToggle
    }
  },
  actions: {
    [types.RECEIVED_PROFILEIMG_FILEPATH] ({ commit }, getTfolder) {
      profileimg.getProfileimg(getTfolder)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_PROFILEIMG_FILEPATH, data.filepath)
          commit(types.SET_PROFILEIMG_TOGGLE, true)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('Try recieve profileimg again', message)
          profileimg.getProfileimg(getTfolder)
            .then((response) => {
              const data2 = JSON.parse(response.request.response)
              commit(types.SET_PROFILEIMG_FILEPATH, data2.filepath)
              commit(types.SET_PROFILEIMG_TOGGLE, true)
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data2 = error.response.data
                message = data2.response
              }
              console.warn('warning !!! Please Refresh Page', message)
              if (message !== '' && message !== undefined) {
                swal({
                  title: '', text: message, html: true, type: 'error'
                }, function () {
                  window.onkeydown = null; window.onfocus = null; swal('')
                })
              }
            })
        })
    },
    [types.POST_PROFILEIMG_SAVE] ({ commit, dispatch }, { getTfolder, filename }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: 'ok',
        cancelButtonText: 'cancel',
        html: true
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          profileimg.postProfileimgSave(getTfolder, filename)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              commit(types.SET_PROFILEIMG_FILEPATH, '')
              commit(types.SET_PROFILEIMG_TOGGLE, false)
              dispatch(types.RECEIVED_PROFILEIMG_FILEPATH, getTfolder)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/profileimg/index.js